<div style="position: relative">
  <mat-card class="mat-card-margin">
    <div class=""></div>
    <div class="evento-header">
      <p>
        <span
          *ngIf="eventoUnidad.evento.categoriaID == 77 || eventoUnidad.evento.categoriaID == 78 || eventoUnidad.evento.categoriaID == 79 || eventoUnidad.evento.categoriaID == 81"
          class="capsule {{eventoUnidad.evento.categoriaID == 81 ? 'ta': 'ev'}}">{{eventoUnidad.evento.categoriaID ==
        81 ? 'Ta' : 'Ev'}}</span>
      </p>
      <div>
        <h3 class="mat-h3" style="margin-bottom: 0;">
          {{eventoUnidad.evento.nombre}}
          <span class="mat-h5">({{eventoUnidad.evento.categoria?.nombre}})</span>
        </h3>
      </div>
      <span class="spacer"></span>
      <div class="evento-header__indicador" *ngIf="!isFamilia">
        <button mat-icon-button (click)="verComentarios()">
          <mat-icon>comment</mat-icon>
        </button>
        <span>
          <sup class="notificaciones-capsule"
            *ngIf="eventoUnidad.comentariosNuevos > 0">{{eventoUnidad.comentariosNuevos}}</sup>
        </span>
        <div class="g-sharetoclassroom" [attr.data-size]="'16'" [attr.data-theme]="'light'"
          [attr.data-title]="eventoUnidad.evento.nombre" [attr.data-body]="eventoUnidad.evento.resumen"
          *ngIf="eventoUnidad.evento.categoria.id == 81">
        </div>
      </div>
      <div *ngIf="!isFamilia">
        <button mat-icon-button class="md-14" [matMenuTriggerFor]="menuEvento">
          <mat-icon class="material-icons md-14">more_vert</mat-icon>
        </button>
        <mat-menu #menuEvento="matMenu" xPosition="before" overlapTrigger="true">
          <button mat-menu-item (click)="editar(eventoUnidad.id)">
            <mat-icon class="material-icons">mode_edit</mat-icon>
            <span>Editar</span>
          </button>
          <button mat-menu-item (click)="retroalimentar()" *ngIf="eventoUnidad.eventoMaterias.length > 0">
            <mat-icon class="material-icons">spellcheck</mat-icon>
            <span>Retroalimentar</span>
          </button>
          <!-- 
          <button mat-menu-item (click)="generatePdf()" *ngIf="eventoUnidad.eventoMaterias.length > 0">
            <mat-icon class="material-icons">print</mat-icon>
            <span>Imprimir retroalimentación</span>
          </button>
          -->
          <button mat-menu-item [matMenuTriggerFor]="tipoEventoMenu">
            <mat-icon class="material-icons">content_copy</mat-icon>
            <span>Duplicar como...</span>
          </button>
          <button (click)="conectarEventoConMetas()" mat-menu-item>
            <mat-icon class="material-icons">link</mat-icon>
            <span>Conectar con metas</span>
          </button>
          <button mat-menu-item (click)="verRubrica()">
            <mat-icon class="material-icons">view_module</mat-icon>
            <span>Ver rúbrica</span>
          </button>
          <button mat-menu-item (click)="generarCsv()">
            <mat-icon class="material-icons">backup_table</mat-icon>
            <span>Descargar rúbrica para Classroom</span>
          </button>
          <button mat-menu-item (click)="borrar()">
            <mat-icon class="material-icons">cancel</mat-icon>
            <span>Quitar de unidad</span>
          </button>
        </mat-menu>

        <mat-menu #tipoEventoMenu="matMenu">
          <button mat-menu-item (click)="duplicarEvento(eventoUnidad.id, 77)">Tarea de desempeño</button>
          <button mat-menu-item (click)="duplicarEvento(eventoUnidad.id, 78)">Otra evidencia</button>
          <button mat-menu-item (click)="duplicarEvento(eventoUnidad.id, 79)">Autoevaluación</button>
          <button mat-menu-item (click)="duplicarEvento(eventoUnidad.id, 80)">Evento de Aprendizaje</button>
          <button mat-menu-item (click)="duplicarEvento(eventoUnidad.id, 81)">Tarea</button>
        </mat-menu>
      </div>
    </div>
    <div class="evento-adicionales">
      <div *ngIf="isFamilia" [innerHtml]="eventoUnidad.evento.resumen"></div>
      <div class="evento-adicionales__items" *ngIf="!isFamilia">
        <div class="full-width" *ngIf="eventoUnidad.retroalimentacionPorcentaje > 0">

          <div class="flex-wrap" style="align-items: baseline;">
            <h3 class="mat-small">Retroalimentacion: {{eventoUnidad.retroalimentacionPorcentaje}}%</h3>
            <div class="spacer"></div>
          </div>
          <div>
            <mat-progress-bar mode="determinate" value="{{eventoUnidad.retroalimentacionPorcentaje}}" color="accent">
            </mat-progress-bar>
          </div>

        </div>
      </div>
      <div class="evento-adicionales__items" style="position: relative;" *ngIf="eventoUnidad.eventoMaterias.length > 0 && !isFamilia">
        <!-- <i class="material-icons" matTooltip="Eventos de aprendizaje">info_outline</i> -->
        <h3 class="mat-small">Materia/Curso</h3>
        <ul style="width: 100%;">
          <li class="chip-materia-curso" *ngFor="let eventoMateria of eventoUnidad.eventoMaterias"
            [ngClass]="{'color-green': eventoMateria.isCompletado}"
            (mouseenter)="setElementVisibilityStatus(menuFecha, 'visible')"
            (mouseleave)="setElementVisibilityStatus(menuFecha, 'hidden')">
            <span class="materia-curso-title" title="{{eventoMateria.nombre}}">{{eventoMateria.nombre}}</span>
            <!-- <span class="spacer"></span> -->
            <div
              [matTooltip]="eventoMateria['fechaValid'] ? 'El evento no será incluido en los informes de esta unidad, al estar fuera del rango de fechas.' : ''"
              class="materia-curso-data mat-small">
              <span>
                <mat-icon class="md-14">calendar_today</mat-icon>
                {{eventoMateria.fechaAplicar | date: 'dd MMM yyyy'}}
              </span>
              <span *ngIf="eventoMateria['fechaValid']">
                <mat-icon  class="md-14">warning</mat-icon>
              </span>
              <span>
                <mat-icon class="md-14">timelapse</mat-icon>
                {{eventoMateria.duracion}} min
              </span>
            </div>
            <div #menuFecha class="materia-curso-data-menu">
              <div *ngIf="!isFamilia">
                <!-- FIXED: Imprimir retroalimentacion de una fecha -->
                <button mat-icon-button class="md-14" matTooltip="Imprimir Retroalimentación" 
                  (click)="generatePdf(eventoMateria.id)">
                  <mat-icon class="md-14">print</mat-icon>
                </button>
                <!--  -->
                <button mat-icon-button class="md-14" matTooltip="Retroalimentar curso"
                  (click)="retroalimentar(eventoMateria.materiaCursoPeriodoID)">
                  <mat-icon class="md-14">spellcheck</mat-icon>
                </button>
                <button mat-icon-button class="md-14" matTooltip="Marcar como realizada"
                  (click)="setEstadoMCP(eventoMateria.id, !eventoMateria.isCompletado)">
                  <mat-icon class="md-14">check</mat-icon>
                </button>
                <button mat-icon-button class="md-14" matTooltip="Editar fecha del evento"
                  (click)="editarEvento(eventoMateria)">
                  <mat-icon class="md-14">edit</mat-icon>
                </button>
              </div>
            </div>
          </li>
        </ul>
        <div *ngIf="editarFecha" class="mat-elevation-z24"
          style="position: absolute; width: 248px; height: auto; background: #FFF; left: 30%; padding: 24px; z-index: 24;">
          <app-unidad-evento-classroom-mcp [eventoMateria]="mcpEdicion" (guardarEvent)="guardarMCP($event)" (cerrarEvent)="editarFecha = false"></app-unidad-evento-classroom-mcp>
        </div>
      </div>
      <div *ngIf="eventoUnidad.metas.length > 0 && !isFamilia" class="evento-adicionales__items">
        <h3 class="mat-small">Metas conectadas</h3>
        <mat-chip-set>
          <mat-basic-chip *ngFor="let metaConectada of eventoUnidad.metas" class="evento-meta-conectada"
            [matTooltip]="metaConectada.txtIdioma">
            {{metaConectada.id}}
          </mat-basic-chip>
        </mat-chip-set>
      </div>
      <div *ngIf="eventoUnidad.recursos.length > 0 && !isFamilia" class="evento-adicionales__items">
        <h3 class="mat-small">Adjuntos</h3>
        <ul>
          <li class="chip-materia-recurso" (mouseenter)="setElementVisibilityStatus(menuRecurso, 'visible')"
            (mouseleave)="setElementVisibilityStatus(menuRecurso, 'hidden')"
            *ngFor="let recurso of eventoUnidad.recursos">
            <a href="{{recurso.url}}" target="_blank">
              <span [ngStyle]="{'color': recurso.isVisibleToStudent ? 'green' : 'inherit'}">
                {{recurso.nombre}}
              </span>
            </a>
            <span class="spacer"></span>
            <div #menuRecurso style="visibility: hidden;">
              <button class="md-14" mat-icon-button matTooltip="Compartir con estudiantes."
                (click)="estadoRecursoEstudiantes(recurso)">
                <mat-icon class="md-14" [ngStyle]="{'color': recurso.isVisibleToStudent ? 'green' : 'inherit'}">share
                </mat-icon>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="isFamilia">
      <div *ngFor="let autoevaluacion of eventoUnidad.eventoMaterias">
        <app-autoevaluacion-notificacion-alumno [fechaAplicar]="autoevaluacion.fechaAplicar" [autoevaluacion]="autoevaluacion.eventoMateriaAlumnoConfig" [unidadEventoMateriaId]="autoevaluacion.id" [alumnoId]="alumnoId"></app-autoevaluacion-notificacion-alumno>
      </div>
    </div>
    <mat-card-actions>
      <button mat-button *ngIf="!isFamilia" (click)="showResumen = !showResumen">
        <label *ngIf="!showResumen">Ver detalles</label>
        <label *ngIf="showResumen">Ocultar detalles</label>
      </button>
      <ng-template #btnRetroalimentacion>
        <button mat-button (click)="verRetroalimentacion()">
          <label>Ver retroalimentación</label>
        </button>
      </ng-template>
    </mat-card-actions>
    <div *ngIf="showResumen" class="evento-resumen">
      <div [innerHtml]="eventoUnidad.evento.resumen | safe: 'html'"></div>
    </div>

    <div *ngIf="working"
      style="position: absolute; width: 100%; height: 100%; background: rgba(0,0,0,0.6); top:0; left: 0;">
      <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
    </div>
  </mat-card>
</div>
